module.exports = __webpack_public_path__ + "img/clipboard-list.259a6d21.svg";